import { FeedbackDto, FeedbackRating } from './feedbackDto';
import { ContactDetailsInput } from '../../components/contactDetails';
import { generateUserHash } from '../../../../services/hash';
import { sendFeedbackToApi, DialogClosedError } from '../../../../services/network';
import { addFeedbackPoints, removeFeedbackPointsLayer } from '../../../../map';

export async function handleSendFeedback(
    coord: [number, number],
    epsg: string,
    rating: FeedbackRating,
    comment: string,
    save: boolean,
    refreshPoints: boolean = true,
    contact?: ContactDetailsInput
): Promise<void> {
    const dto: FeedbackDto = {
        coordinate: coord,
        epsg,
        rating,
        comment,
        save,
        userHash: generateUserHash(),
        contact
    };

    try {
        await sendFeedbackToApi(dto);
    } catch (error) {
        if (error instanceof DialogClosedError) {
            alert('Dialogen tar inte emot svar just nu.');
            return;
        }
        throw error;
    }

    // Update feedback points on the map immediately (if they are shown to the public)
    if (refreshPoints) {
        removeFeedbackPointsLayer();
        await addFeedbackPoints();
    }
}
